import { VIR_DAILY_PHOTOS_ARRAY, VIR_WEEKLY_PHOTOS_ARRAY } from './vir'

//! keep consistent with mobile and backend
const PRE_INSTALL_IMAGE_TYPES = {
  pre_front_driver: 'pre_front_driver',
  pre_front_driver_damage: 'pre_front_driver_damage',
  pre_front_passenger: 'pre_front_passenger',
  pre_front_passenger_damage: 'pre_front_passenger_damage',
  pre_rear_passenger: 'pre_rear_passenger',
  pre_rear_passenger_damage: 'pre_rear_passenger_damage',
  pre_rear_driver: 'pre_rear_driver',
  pre_rear_driver_damage: 'pre_rear_driver_damage',
  pre_vin: 'pre_vin',
  pre_additional: 'pre_additional',
}

const ORDER_DETAILS_IMAGE_TYPES = {
  torque_wrench_setting: 'torque_wrench_setting',
  first_lug_first_torque: 'first_lug_first_torque',
  left_work_area: 'left_work_area',
  right_work_area: 'right_work_area',
}

const postInstallImageTypesTarget: { [key: string]: string } = {
  post_front_driver: 'post_front_driver',
  post_front_passenger: 'post_front_passenger',
  post_rear_passenger: 'post_rear_passenger',
  post_rear_driver: 'post_rear_driver',
  pre_wiper_windshield: 'pre_wiper_windshield',
  post_wiper_windshield: 'post_wiper_windshield',
  post_additional: 'post_additional',
}

const POST_INSTALL_IMAGE_TYPES = new Proxy(postInstallImageTypesTarget, {
  get: (target, prop: string) => {
    return prop.startsWith('dot_number_') ? prop : target[prop]
  },
})

const CANCEL_INSTALL_IMAGE_TYPES = 'cancellation'

const DELIVERY_CONFIRMATION_IMAGE_TYPES = {
  delivery_confirmation: 'delivery_confirmation',
  additional_photos: 'additional_photos',
}

const DELIVERY_CANCELLATION_IMAGE_TYPES = {
  delivery_cancellation: 'delivery_cancellation',
  additional_photos: 'additional_photos',
}

export {
  PRE_INSTALL_IMAGE_TYPES,
  ORDER_DETAILS_IMAGE_TYPES,
  POST_INSTALL_IMAGE_TYPES,
  CANCEL_INSTALL_IMAGE_TYPES,
  DELIVERY_CONFIRMATION_IMAGE_TYPES,
  DELIVERY_CANCELLATION_IMAGE_TYPES,
}

// * the following are used within the frontend only
enum VAN_IMAGE_TYPES {
  qr_code = 'qr_code',
}

enum SMALL_PART_SUPPLIES_IMAGE_TYPES {
  qr_code = 'qr_code',
}

const REQUIRED_INSTALLATION_IMAGE_BY_TYPE: string[] = [
  PRE_INSTALL_IMAGE_TYPES.pre_front_driver,
  PRE_INSTALL_IMAGE_TYPES.pre_front_passenger,
  PRE_INSTALL_IMAGE_TYPES.pre_rear_driver,
  PRE_INSTALL_IMAGE_TYPES.pre_rear_passenger,
  PRE_INSTALL_IMAGE_TYPES.pre_vin,
  ORDER_DETAILS_IMAGE_TYPES.first_lug_first_torque,
  ORDER_DETAILS_IMAGE_TYPES.torque_wrench_setting,
  POST_INSTALL_IMAGE_TYPES.post_front_driver,
  POST_INSTALL_IMAGE_TYPES.post_front_passenger,
  POST_INSTALL_IMAGE_TYPES.post_rear_driver,
  POST_INSTALL_IMAGE_TYPES.post_rear_passenger,
  POST_INSTALL_IMAGE_TYPES.pre_wiper_windshield,
  POST_INSTALL_IMAGE_TYPES.post_wiper_windshield,
  CANCEL_INSTALL_IMAGE_TYPES,
  DELIVERY_CONFIRMATION_IMAGE_TYPES.delivery_confirmation,
  DELIVERY_CANCELLATION_IMAGE_TYPES.delivery_cancellation,
]

const REQUIRED_DVIR_IMAGE_BY_TYPE: string[] = [
  ...VIR_DAILY_PHOTOS_ARRAY,
  ...VIR_WEEKLY_PHOTOS_ARRAY,
]

export {
  VAN_IMAGE_TYPES,
  SMALL_PART_SUPPLIES_IMAGE_TYPES,
  REQUIRED_INSTALLATION_IMAGE_BY_TYPE,
  REQUIRED_DVIR_IMAGE_BY_TYPE,
}
